import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { eur } from "@/lib/api";
import { resolveButtonStyle } from "@/lib/ctaButtonStyle";
import RichText from "@/components/RichText";

// "product_id" est l'id interne du produit (jamais son nom/prix dénormalisé,
// voir theme_service._verify_catalog_refs côté backend) — ce composant le
// résout en produit réel via l'endpoint public existant `/products?ids=`
// (Sprint 6, réutilise `list_products` plutôt qu'un nouvel endpoint dédié).
export default function FeaturedProductSection({ props = {} }) {
  const { product_id, heading, cta_label } = props;
  const [product, setProduct] = useState(null);
  const ctaStyle = resolveButtonStyle(props, "cta");

  useEffect(() => {
    if (!product_id) { setProduct(null); return; }
    let cancelled = false;
    api.get("/products", { params: { ids: product_id } }).then(({ data }) => {
      if (!cancelled) setProduct(data?.[0] || null);
    }).catch(() => { if (!cancelled) setProduct(null); });
    return () => { cancelled = true; };
  }, [product_id]);

  if (!product_id || !product) return null;

  return (
    <section className="max-w-[1240px] mx-auto px-6 md:px-10 py-section md:py-section-md">
      <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-center">
        <img src={product.image} alt={product.name} className="w-full rounded-2xl object-cover aspect-square" />
        <div>
          {heading && (
            <RichText as="p" className="text-[13px] uppercase tracking-[0.12em] text-ash mb-3" html={heading} />
          )}
          <h2 className="font-display font-semibold text-[28px] md:text-[36px] leading-tight tracking-[-0.02em] text-ink">
            {product.name}
          </h2>
          <div className="flex items-baseline gap-2.5 mt-4">
            <span className="text-[22px] font-medium text-ink">{eur(product.price)}</span>
            {product.original_price && (
              <span className="text-base text-ash line-through">{eur(product.original_price)}</span>
            )}
          </div>
          {product.short_description && (
            <p className="text-[15px] text-graphite mt-4 leading-relaxed">{product.short_description}</p>
          )}
          <Link
            to={`/produit/${product.slug}`}
            className={`inline-flex items-center gap-2 bg-ink text-white px-7 py-3.5 text-[15px] font-semibold hover:opacity-90 transition-opacity mt-8 ${ctaStyle.className}`}
            style={ctaStyle.style}
            aria-label={!ctaStyle.showText ? (cta_label || "Voir le produit") : undefined}
          >
            {ctaStyle.showIcon && ctaStyle.Icon && <ctaStyle.Icon className="h-4 w-4" />}
            {ctaStyle.showText && (cta_label || "Voir le produit")}
          </Link>
        </div>
      </div>
    </section>
  );
}
